export default __webpack_public_path__ + "b16815f97330319e89d042972d68f841.webp";